import { Injectable, Injector } from '@angular/core'
import { Overlay } from '@angular/cdk/overlay'
import { ComponentPortal } from '@angular/cdk/portal'
import { KeyingToastComponent } from './toast.component'
import { ToastData } from './toast-config'
import { ToastRef } from './toast-ref'

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  lastRef: ToastRef

  constructor(private overlay: Overlay, private parentInjector: Injector) {}

  showToast(data: ToastData) {
    if (this.lastRef) {
      this.lastRef.close()
    }

    const positionStrategy = this.overlay.position().global().top().right()
    const overlayRef = this.overlay.create({
      positionStrategy,
    })

    const toastRef = new ToastRef(overlayRef)
    const injector = this.getInjector(data, toastRef, this.parentInjector)
    const toastPortal = new ComponentPortal(KeyingToastComponent, null, injector)

    overlayRef.attach(toastPortal)

    this.lastRef = toastRef
    return toastRef
  }

  close(): void {
    this.lastRef?.close()
  }

  getInjector(data: ToastData, toastRef: ToastRef, parentInjector: Injector) {
    return Injector.create({
      parent: parentInjector,
      providers: [
        { provide: ToastData, useValue: data },
        { provide: ToastRef, useValue: toastRef }
      ]
    })
  }
}
